export const hyb_udata:string = 'hyb_udata';
export const hyb_udetail:string = 'hyb_udetail';
export const hyb_compdetail:string = 'hyb_compdetail';
export const sesssionExpired:string = 'sesssionExpired';
export const walletAPIInterval:number = 5000;